import axios from 'axios';
import { DefaultFishGroupProfileAssortment } from '../../types/default-fish-group-profile-assortment.type';

// GET
// /ewosapi/v2/planandprognosis/default-profile/fishgroup/{fishGroupId}
export const getDefaultFishGroupProfiles = async (fishGroupId: string): Promise<DefaultFishGroupProfileAssortment> => {
  const res = await axios.get<DefaultFishGroupProfileAssortment>(
    `/ewosapi/v2/planandprognosis/default-profile/fishgroup/${fishGroupId}`
  );
  return res.data;
};
